import { AxiosError } from 'axios';

type AmondzErrorResponseType = {
  errors?: {
    code?: string;
    message?: string;
  }[];
};

export type ErrorResponseType = Error | AxiosError<AmondzErrorResponseType>;

export const extractErrorMessage = (
  error: ErrorResponseType,
  defaultErrorMessage = '예기치 않은 에러가 발생했습니다.',
): string => {
  if (error instanceof AxiosError) {
    const axiosError = error as AxiosError<AmondzErrorResponseType>;
    if (
      axiosError.response &&
      axiosError.response.data &&
      axiosError.response.data.errors &&
      axiosError.response.data.errors.length > 0
    ) {
      const errorObject = axiosError.response.data.errors[0];
      return errorObject.message || defaultErrorMessage;
    }
  }
  return error.message || defaultErrorMessage;
};
